const API_BASE =
  process.env.REACT_APP_API_BASE ||
  "https://smallbizskills-api-303547506875.us-central1.run.app";

const PRODUCT_MAP = {
  quick:            "market_intelligence_quick",
  full:             "market_intelligence",
  profiles:         "market_intelligence_profiles",
  competitor_check: "competitor_check",
};

export async function createCheckoutSession(reportType = "full", payload = {}) {
  const product = PRODUCT_MAP[reportType] || "market_intelligence";
  const returnBase = window.location.origin + window.location.pathname;
  const extra = new URLSearchParams();
  if (payload.business_type)  extra.set("bt",  payload.business_type);
  if (payload.location)       extra.set("loc", payload.location);
  if (payload.center_address) extra.set("ca",  payload.center_address);
  extra.set("rt", reportType);
  const successUrl = `${returnBase}?session_id={CHECKOUT_SESSION_ID}&${extra.toString()}`;
  const res = await fetch(`${API_BASE}/payments/create-checkout`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ product, success_url: successUrl, cancel_url: returnBase }),
  });
  if (!res.ok) throw new Error("Could not create checkout session");
  const { checkout_url } = await res.json();
  window.location.href = checkout_url;
}

export async function fetchProfiles(payload, stripeSessionId) {
  const res = await fetch(`${API_BASE}/intelligence/analyze`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ ...payload, profiles_only: true, stripe_session_id: stripeSessionId }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.detail || `Request failed (${res.status})`);
  }
  return res.json();
}

export async function runCompetitorCheck(payload, stripeSessionId) {
  const res = await fetch(`${API_BASE}/competitors/check`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      business_type: payload.business_type,
      location: payload.location,
      center_address: payload.center_address || undefined,
      stripe_session_id: stripeSessionId,
    }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.detail || `Request failed (${res.status})`);
  }
  return res.json();
}

export async function analyzeMarket(payload, stripeSessionId) {
  const res = await fetch(`${API_BASE}/intelligence/analyze`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ ...payload, stripe_session_id: stripeSessionId }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.detail || `Request failed (${res.status})`);
  }
  return res.json();
}
